import { Stack, Typography } from '@mui/material'

interface Props {
  sender: string
  recipient: string
}

export function SentBy(props: Props) {
  const { sender, recipient } = props

  return (
    <Stack direction="column" spacing={0}>
      <Typography variant="caption" color="text.secondary">
        {sender}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {recipient}
      </Typography>
    </Stack>
  )
}
